// assets.
import { IconFilter } from '@assets/icons';

type SortOrder = 'asc' | 'desc';

interface Props {
  order: SortOrder;
  onToggle: () => void;
}

export const SortDataFilter = ({ onToggle }: Props) => {
  return (
    <span
      onClick={onToggle}
      style={{
        alignItems: 'center',
        display: 'inline-flex',
        padding: '4px',
        cursor: 'pointer',
        gap: 4,
      }}
    >
      <span role="img" aria-label="Ordenar por fecha">
        <IconFilter />
      </span>
    </span>
  );
};
